import { Injectable } from '@angular/core';
import { CognitoUtil } from '../../../routing/services/cognito/cognito.service';
import { Callback } from '../../../routing/interfaces/cognito.i';
import { CommonService } from '../../../../common/services/common.service'

@Injectable()
export class UserParametersService {

    constructor(public cognitoUtil: CognitoUtil,
        public commonService: CommonService) {
    }

    getParameters(callback: Callback): void {
        const cognitoUser = this.cognitoUtil.getCurrentUser();

        if (cognitoUser !== undefined) {
            cognitoUser.getSession( (err, session) => {
                if (err) {
                    //TO DO
                  } else {
                    cognitoUser.getUserAttributes( (err, result) => {
                        if (err) {
                            //TO DO
                        } else {
                            this.commonService.emitCongitoUserAtrributes();
                            callback.callbackWithParam(result);
                        }
                    });
                }

            });
        } else {
            callback.callbackWithParam(undefined);
        }
    }
}
